'use client'
import React, { useState } from 'react'
import { getTrackingService } from '@/services/tracking/TrackingInstance'
import LocationPill from './LocationPill'

interface LocationPillStateProps {
  initialData?: {
    city: string
    url: string
    degrees: number
    symbol: string
    warning?: string
  }
}

const LocationPillState: React.FC<LocationPillStateProps> = ({
  initialData,
}) => {
  const trackingService = getTrackingService()
  const [data] = useState(
    initialData || { city: '', url: '', degrees: 0, symbol: '', warning: '' },
  )

  const handleClick = () => {
    trackingService.addAndExecuteCommand('navigation_clicked', {
      navigation_type: ['Berlin', 'Köln'].includes(data.city)
        ? 'location-default'
        : 'location-custom',
      navigation_text: data.city,
      navigation_path: data.url,
    })
  }

  return <LocationPill {...data} onClick={handleClick} />
}

export default LocationPillState
